var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_14653)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_281_14653)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5665 17.621C69.494 18.4047 71.7949 20.7053 72.5784 23.6329C73.9946 28.9339 74.0003 40.0004 74.0003 40.0004C74.0003 40.0004 74.0003 51.0671 72.5784 56.3681C71.7949 59.2956 69.494 61.5962 66.5665 62.3798C61.2657 63.8017 40 63.8017 40 63.8017C40 63.8017 18.7346 63.8017 13.4337 62.3798C10.5061 61.5962 8.20548 59.2956 7.4218 56.3681C6 51.0671 6 40.0004 6 40.0004C6 40.0004 6 28.9339 7.4218 23.6329C8.20548 20.7053 10.5061 18.4047 13.4337 17.621C18.7346 16.1992 40 16.1992 40 16.1992C40 16.1992 61.2657 16.1992 66.5665 17.621ZM50.8599 40.0011L33.1936 50.1999V29.8021L50.8599 40.0011Z",
    fill: "#F2DB1E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_14653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.0001,
    height: 47.6024,
    fill: "white",
    transform: "translate(6 16.1992)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_281_14653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.0001,
    height: 47.6024,
    fill: "white",
    transform: "translate(6 16.1992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.26c2fafb05e32776952cca72936839ec.svg";
export { ForwardRef as ReactComponent };